<!-- 无数据 -->
<template>
  <div class="flex flex-col items-center">
    <img :src="$getImageSrc(image)" class="mt-20 mb-4" />
    <p class="mb-2">{{ text }}</p>
    <p class="text-sm text-gray-400 mb-4">{{ text2 }}</p>
    <p class="bg-[#e5ba89] text-white rounded cursor-pointer hover:bg-[#d8a367]" v-if="toText">
      <a v-if="to==='resume'" href="resume.html" target="_blank" class="w-full h-full px-8 py-3 inline-block">{{ toText }}</a>
      <router-link v-else :to="to" class="w-full h-full px-8 py-3 inline-block">{{ toText }}</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    text: {
      type: String,
      default: '没有数据哦',
    },
    text2: {
      type: String,
      default: '没有数据哦',
    },
    image: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
    toText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped></style>
